let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fp6pG")).then(() => parcelRequire('QPojr'));